// https://gist.github.com/atomiks/25ba93a551fc1e8a1ef18aa7669c6699
import React from 'react';
import ReactDOM from 'react-dom';
import tippy from 'tippy.js';

const DEFAULT_TOOLTIP_STYLE = {
  fontSize: '14px',
  lineHeight: '1.5',
  textAlign: 'left',
  color: 'white',
  maxWidth: '400px',
  wordWrap: 'break-word',
};

class Tippy extends React.Component {
  html = React.createRef();

  componentDidMount() {
    /* eslint-disable no-unused-vars */
    /* eslint-disable react/no-find-dom-node */
    const { children, ...props } = this.props;
    this.tippyInstance = tippy.one(ReactDOM.findDOMNode(this), {
      ...props,
      html: this.html.current,
      animateFill: false, //文字数が多いと見切れるのでfalse
    });
    if (this.props.disable) {
      this.tippyInstance.disable();
    }
  }

  componentDidUpdate() {
    if (!this.props.html) {
      this.tippyInstance.popper.querySelector('.tippy-content')[
        this.props.allowTitleHTML ? 'innerHTML' : 'textContent'
      ] = this.props.children.props.title;
    }

    if (this.props.disable) {
      this.tippyInstance.hide(0);
      this.tippyInstance.disable();
    } else {
      this.tippyInstance.enable();
    }
  }

  componentWillUnmount() {
    if (this.tippyInstance) {
      this.tippyInstance.destroy();
      this.tippyInstance = null;
    }
  }

  hide(duration) {
    this.tippyInstance.hide(duration);
  }

  render() {
    return (
      <React.Fragment>
        {this.props.children}
        {this.props.html && <div ref={this.html}>{this.props.html}</div>}
      </React.Fragment>
    );
  }
}

export const ToolTip = ({ children, tooltipStyle }) => {
  const style = {
    ...DEFAULT_TOOLTIP_STYLE,
    ...tooltipStyle,
  };
  return <div style={style}>{children}</div>;
};

/**
 * create props boundary use for popperOptions
 * @param boundary {string | HTMLElement}: can be 'scrollParent', 'window', 'viewport' or any DOM element.
 * @return {Object}
 */
export const createPopperBoundaryProps = (boundary) => {
  return {
    modifiers: {
      preventOverflow: {
        boundariesElement: boundary
      }
    }
  };
};

export default Tippy;



// WEBPACK FOOTER //
// ./src/components/ReactTippy.jsx